import urwhitearrow from "../assets/images/icons/urwhitearrow.svg";
import primaryArrow from "../assets/images/icons/primaryarrow.svg";
import user from "../assets/images/icons/user.svg";
import upAngle from "../assets/images/icons/angleup.svg";
import rightDarkArrow from "../assets/images/icons/forwardarrow.svg";
import leftDarkArrow from "../assets/images/icons/backwardarrow.svg";

export const icons = {
  urwhitearrow,
  user,
  primaryArrow,
  upAngle,
  rightDarkArrow,
  leftDarkArrow,
};
